import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import CMSMicrositeWithMetadata from './CMSMicrositeWithMetadata'
import { useActiveMicrositesMetadataList } from '../../common/hooks/useActiveMicrositesMetadataList'

export const CMSMicrositeRouter = () => {
  const activeMicrosites = useActiveMicrositesMetadataList()
  const location = useLocation()
  const currentPath = location.pathname

  const matchedMetadata = activeMicrosites.find((metadata) => currentPath === `/${metadata.micrositeUrl}`)

  if (!matchedMetadata) {
    return <Navigate to='/' replace />
  }

  return <CMSMicrositeWithMetadata micrositeMetadata={matchedMetadata} />
}
